import React from 'react';

const SongInfoReportAll = ({ selectedTitles }) => {

  return (
    <>
      <h3 className="text-center">
        {selectedTitles.length > 0 ? (
          <span>You are reporting {selectedTitles.length} title(s):</span>
        ) : (
          <span>Report selectedTitles</span>
        )}
      </h3>

      {selectedTitles.length > 0 &&
        <div className='mb-25'>
          {selectedTitles.map((title, index) => {
            return (
              <h4 key={index} className="text-center">{title}</h4>
            );
          })}
        </div>
      }

      {!selectedTitles.length &&
        <div className="alert alert-info" role="alert">
          No selectedTitles selected to report!
        </div>
      }
    </>
  );
};

export default SongInfoReportAll;
